import React, { Fragment, memo, useState, useEffect, } from 'react';
import { Row, Nav, Col, Modal } from "react-bootstrap";
import Botones from '../../../components/UI/botonera/headerBotones.js';
import { faReply } from '@fortawesome/free-solid-svg-icons';



function modalCorporaciones(props) {

    return (
        <Fragment>
            <Modal size="lg" show={props.show} animation={false} onHide={() => { props.cerrarModal(false) }}>
                {/*<Modal.Header closeButton="false">
        <Modal.Title>{props.titulo}</Modal.Title>
    </Modal.Header>*/}
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="col-md-12">
                                <div className='row'>
                                    <div className="col-md-6">
                                        <h1>{props.titulo}</h1>
                                    </div>
                                    <div className="col-md-6 text-right">
                                        <div className="acciones">
                                            <Botones
                                                botones={props.botones}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="content">
                                    <div className="content-box">
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <p className="info"><span>{`${props.Datos.Id.attributes.label}: `}</span>{props.Datos.Id.value}</p>
                                                <p className="info"><span>{`${props.Datos.Nombre.attributes.label}: `}</span>{props.Datos.Nombre.value}</p>
                                                <p className="info"><span>{`${props.Datos.CedulaJuridica.attributes.label}: `}</span> {props.Datos.CedulaJuridica.value}</p>
                                                <p className="info"><span>{`${props.Datos.Email.attributes.label}: `}</span> {props.Datos.Email.value}</p>

                                            </div>
                                            <div className="col-md-6">
                                                <p className="info"><span>{`${props.Datos.Site.attributes.label}: `}</span> {props.Datos.Site.value}</p>
                                                <p className="info"><span>{`${props.Datos.Telefono.attributes.label}: `}</span> {props.Datos.Telefono.value}</p>
                                                <p className="info"><span>{`${props.Datos.Fax.attributes.label}: `}</span> {props.Datos.Fax.value}</p>
                                                
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <p className="info"><span>{`${props.Datos.Direccion.attributes.label}: `}</span> {props.Datos.Direccion.value}</p>
                                            </div>
                                            </div>                                                                                
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                {/* <Modal.Footer>
        <Botones
            botones={props.botones}
        />
    </Modal.Footer>*/}
            </Modal>
        </Fragment>
    );
};
export default modalCorporaciones;